import * as actionTypes from './actionTypes'

export const add = valueToAdd => {
  return {
    type: actionTypes.TAGGED_INPUT_TEXT_ADD,
    payload: valueToAdd,
  }
}

export const remove = valueToRemove => {
  return {
    type: actionTypes.TAGGED_INPUT_TEXT_REMOVE,
    payload: valueToRemove,
  }
}

export const reset = () => {
  return {
    type: actionTypes.TAGGED_INPUT_TEXT_RESET,
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/TaggedInputText.js